import { render, staticRenderFns } from "./calendar-settings-dialog-field.vue?vue&type=template&id=54f8749f"
import script from "./calendar-settings-dialog-field.vue?vue&type=script&lang=js"
export * from "./calendar-settings-dialog-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports